import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';
import { env } from '@/env';

export default function AppStoreRedirect() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code') || '';
    const retailer_id = searchParams.get('retailer_id') || '';
    mixpanel.track('open-invite', { code, retailer_id });
  }, [searchParams]);

  return (
    <>
      <div
        style={{
          backgroundColor: '#f7f7f7',
          fontFamily: "'Outfit', sans-serif",
          color: '#333',
          textAlign: 'center',
          padding: '50px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          margin: 0,
        }}
      >
        <div
          style={{
            backgroundColor: '#ffffff',
            padding: '40px',
            borderRadius: '12px',
            boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)',
            maxWidth: '400px',
            textAlign: 'center',
          }}
        >
          <img
            src="/icons/logo_landw.svg"
            alt="App Logo"
            style={{
              width: '120px',
              height: 'auto',
              marginBottom: '30px',
              display: 'inline',
            }}
          />
          <h1
            style={{
              fontSize: '3rem',
              marginBottom: '20px',
              fontFamily: 'Outfit',
              fontWeight: 800,
            }}
          >
            agrantis LandwirteApp
          </h1>
          <p
            style={{
              fontSize: '1.8rem',
              fontFamily: 'Outfit',
              marginBottom: '30px',
              color: '#666',
            }}
          >
            Bitte laden Sie sich die App unter folgendem Link herunter
          </p>

          <a
            href={`market://details?id=${env.VITE_GOOGLE_PLAY_STORE_APP_ID}`}
            style={{ display: 'block', lineHeight: 0, padding: '6px' }}
          >
            <img src="/icons/playStore.svg" style={{ display: 'inline' }} />
          </a>

          <a
            href={env.VITE_APPLE_APP_STORE_APP_URL}
            style={{ display: 'block', lineHeight: 0, padding: '6px' }}
          >
            <img src="/icons/appStore.svg" style={{ display: 'inline' }} />
          </a>
        </div>
      </div>
    </>
  );
}
